
import axios, { CancelToken } from 'axios';
import { MadeInStoreClient, MadeInStoreItemRequest, PagedData_1OfMadeInStoreItem, SuccessResponse_1OfList_1OfItemRecipeSummary, CreateMadeInStoreItemRequestDto, ConversionsClient, GetConversionsResponseDto, StockCheck, StockClient, SuccessResponse_1OfGetStockResponse, SuccessResponse_1OfItem, UsersClient, SuccessResponse_1OfRAG, SuccessResponse_1OfUser, StockCheckClient, ReportsClient, TransactionsClient, PurchaseOrdersClient, TasksClient, ConfigurationsClient, ResetPasswordRequestDto, StockCountSummaryReportRequest, SuccessResponse_1OfIEnumerable_1OfStockCheckRAG, SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived, ConfigurationName, SuccessResponse_1OfGetConfigurationResponse, SuccessResponse_1OfGetTasksResponse, ActualTheorySummary, StockCheckItem, SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag, LocationsClient, LocationRequest, SuccessResponse_1OfPostLocationResponse, SuccessResponse_1OfLocationResponse, SuccessResponse_1OfIEnumerable_1OfLocationResponse, GenericLocationResponse, SuccessResponse_1OfGetReportsResponse, SuccessResponse_1OfPagedData_1OfStockCheck, StockCheckStatus, TransfersClient, SuccessResponse_1OfGetTransfersResponse, CreateTransferRequest, ReceiveTransferHeaderRequest, SuccessResponse_1OfTransferHeader, ValidateItemQuantityRequest, ValidateItemQuantityResponse, InvoiceClient, SuccessResponse_1OfGetInvoicesResponse, WasteClient, WasteCheckSheetRequest, SuccessResponse_1OfWasteCheckSheetResponse, SuccessResponse_1OfPagedData_1OfWasteHeaders, ItemsClient, SuccessResponse_1OfGetItemsResponse, GetItemsByIdsRequest, SuccessResponse_1OfList_1OfItem, SuccessResponse_1OfGetPurchaseOrderHeadersResponse, SuccessResponse_1OfPurchaseOrderHeader, CreatePurchaseOrderHeaderRequest, AddItemsInPurchaseOrderRequest, ItemAndComponentClient, PagedData_1OfRecipe, SuccessResponse_1OfStoreListResponse, StoresClient, RequestStockCountsVsUsageReportRequest, StockDaysRequest, StockOnHandReportRequest, RequestTheoryActualReportRequest, TransfersReportRequest, WasteReportRequest, DcShortageReportRequest, CreditPurchaseReportRequest, CostOfSalesRequest, ConstrainedItemReportRequest, RequestCOGsReportRequest, CheckReportRequest, MadeInStoreReportRequest, InvoiceReconciliationRequest, ItemTimeOutRequest, ItemStockOutRequest, ItemActivityReportRequest, ExtendedStockCountReportRequest, ReceiptsReportRequest, ProductMarginReportRequest, FileResponse, SuccessResponse_1OfList_1OfDateTime, PrimaryCategoryClient, SuccessResponse_1OfStockCheckDetails, StockCheckScheduleClient, SuccessResponse_1OfList_1OfStockCheckScheduleDetail, DistrictsClient, SuccessResponse_1OfList_1OfUser, SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict, SuccessResponse_1OfOrderTypesResponse, SuccessResponse_1OfPagedData_1OfProductTransactionSearch, SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse, SuccessResponse_1OfGetReasonsResponse, FactId, TransactionTypesClient, TransactionReasonsClient, CreateMultipleTransactionsRequest, SuccessResponse_1OfGetUomsResponse, SuccessResponse_1OfList_1OfPrimaryCategoryStockCount, UpsertItemComponent, PersonasClient, RolesClient, PutPersonaRequest, PostPersonaRequest, SuccessResponse_1OfIEnumerable_1OfPersona, SuccessResponse_1OfIEnumerable_1OfFranchise, SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString, ItemHistoryClient, PutStockRequest, RequestItemHistoryReportRequest, SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification, NotificationsClient, SuccessResponse_1OfSuccessResponse_1OfNotification, SuccessResponse_1OfBoolean, CalculateDiscrepanciesLine, PutPurchaseOrderHeaderRequest, PatchTransactionTypeRequest, PostReasonRequest, SuccessResponse_1OfInvoice, UpdateInvoiceRequest, SuccessResponse_1OfIEnumerable_1OfCreditRequestValue, SuccessResponse_1OfIEnumerable_1OfCreditRequestRag, ItemCompare, PagedData_1OfGroupedItemFeedChange, PagedData_1OfItemFeedChange, PutUserRequest, SuccessResponse_1OfUserListResponse, CreateUserRequestDto, Roles, StockCheckScheduleDetail, SuccessResponse_1OfStockCheckScheduleDetails, PrimaryCategory, SuccessResponse_1OfPrimaryCategory, SuccessResponse_1OfBulkAddResponse, UpdateConfigurationRequest, SuccessResponse_1OfReturnToVendorHeaders, SendCreditReqRequest, BeginCreditReqRequest, GenericCreditRequestResponse, SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse, SourceTransactionsClient, SuccessResponse_1OfGetSourceTransactionsResponse, GetItemsByStoresRequest, AdjustPurchaseOrderRequestDto, AutomatedTasksClient, SuccessResponse_1OfAutomatedTaskDetails, SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString, SuccessResponse_1OfList_1OfAutomatedTask, AutomatedTask, SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate, GetItemsRequestDto, SuccessResponse_1OfList_1OfCostHistory, SuccessResponse_1OfStockItem, SuccessResponse_1OfPostReturnToVendorResponse, ReturnToVendorRequest, StockCheckUomsClient, UpdateStockCheckUomsRequest, SuccessResponse_1OfGetStockCheckUomResponse, SuccessResponse_1OfFranchiseOrderTypes, SuccessResponse_1OfDateTime, SuccessResponse_1OfList_1OfItemDailyHistory, ItemUsageReportRequest, ActivateUserRequestDto, SuccessResponse_1OfInt32, SuccessResponse_1OfSupplierResponse, AIPerformanceReportRequest, PodWidgetType, PodWidgetData, ReturnablePackagingReportRequest, TransportCostsClient, SuccessResponse_1OfList_1OfTransportCost, TransportCost, SuccessResponse_1OfTransportCost, POSMappingClient, PaperPackagingClient, SearchItemsByStoresRequest, SuccessResponse_1OfPagedData_1OfGetPosMappingResponse, SuccessResponse_1OfPagedData_1OfGetPaperPackagingResponse, PostPosMappingRequest, PutPosMappingRequest, DeletePosMappingRequest, PostPaperPackagingRequest, PutPaperPackagingRequest, DeletePaperPackagingRequest, SuccessResponse_1OfList_1OfVoidedTransaction, GenerateStockCheckResponse, BulkUserActionRequest } from '../../app/services/api/generated';
import { createAuthenticatedAxiosInstance } from '../../app/services/api/authenticatedAxios';
import { getApiConfig } from '../../app/services/environment';
import { useNavigate } from 'react-router-dom';

const useNswagClient = () => {

  const navigate = useNavigate();
  const baseUrl = '';
  const axiosInstance = createAuthenticatedAxiosInstance({ transformResponse: [] });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const { response } = error;
      if (response && response.status === 401) {
        localStorage.clear();
        navigate('/login');
      }
      return Promise.reject(error);
    },
  );

  const usersClient = new UsersClient(baseUrl, axiosInstance);
  const stockCheckClient = new StockCheckClient(baseUrl, axiosInstance);
  const reportsClient = new ReportsClient(baseUrl, axiosInstance);
  const transactionsClient = new TransactionsClient(baseUrl, axiosInstance);
  const transactionTypesClient = new TransactionTypesClient(baseUrl, axiosInstance);
  const transactionReasonsClient = new TransactionReasonsClient(baseUrl, axiosInstance);
  const purchaseOrdersClient = new PurchaseOrdersClient(baseUrl, axiosInstance);
  const tasksClient = new TasksClient(baseUrl, axiosInstance);
  const configurationsClient = new ConfigurationsClient(baseUrl, axiosInstance);
  const primaryCategoryClient = new PrimaryCategoryClient(baseUrl, axiosInstance);
  const locationsClient = new LocationsClient(baseUrl, axiosInstance);
  const storesClient = new StoresClient(baseUrl, axiosInstance);
  const transfersClient = new TransfersClient(baseUrl, axiosInstance);
  const invoiceClient = new InvoiceClient(baseUrl, axiosInstance);
  const wasteClient = new WasteClient(baseUrl, axiosInstance);
  const itemsClient = new ItemsClient(baseUrl, axiosInstance);
  const personaClient = new PersonasClient(baseUrl, axiosInstance);
  const rolesClient = new RolesClient(baseUrl, axiosInstance);
  const itemHistoryClient = new ItemHistoryClient(baseUrl, axiosInstance);
  const automatedTask = new AutomatedTasksClient(baseUrl, axiosInstance);
  const itemAndComponentClient = new ItemAndComponentClient(baseUrl, axiosInstance);
  const districtsClient = new DistrictsClient(baseUrl, axiosInstance);
  const stockCheckScheduleClient = new StockCheckScheduleClient(baseUrl, axiosInstance);
  const conversionsClient = new ConversionsClient(baseUrl, axiosInstance);
  const stockClient = new StockClient(baseUrl, axiosInstance);
  const madeInStoreClient = new MadeInStoreClient(baseUrl, axiosInstance);
  const notificationsClient = new NotificationsClient(baseUrl, axiosInstance);
  const sourceTransactionsClient = new SourceTransactionsClient(baseUrl, axiosInstance);
  const stockCheckUomsClient = new StockCheckUomsClient(baseUrl, axiosInstance);
  const posMappingClient = new POSMappingClient(baseUrl, axiosInstance);
  const paperPackagingClient = new PaperPackagingClient(baseUrl, axiosInstance);

  const transportCostClient = new TransportCostsClient(baseUrl, axiosInstance);

  const getCurrentUser = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfUser> => {
    return usersClient.currentuser(cancelToken);
  };

  const resetPassword = (body?: ResetPasswordRequestDto, cancelToken?: CancelToken | undefined): Promise<void> => {
    return usersClient.resetpassword(body, cancelToken);
  };

  const activateUser = (body?: ActivateUserRequestDto, cancelToken?: CancelToken | undefined): Promise<void> => {
    return usersClient.activate(body, cancelToken);
  };

  const getStockCheckDetails = (
    id?: number,
    cancelToken?: CancelToken,
  ): Promise<SuccessResponse_1OfStockCheckDetails> => {
    return stockCheckClient.stockcheckGET2(id ?? 0, cancelToken);
  };

  const getStockCheckRag = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> => {
    return stockCheckClient.rag2(cancelToken);
  };

  const getStockCheckByRagStatus = (red: boolean, amber: boolean, green: boolean, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfStockCheckRAG> => {
    return stockCheckClient.g(red, amber, green, cancelToken);
  };

  const getStockChecks = (storeNumber?: string | undefined, search?: string | undefined, date?: string | undefined, status?: StockCheckStatus | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfStockCheck> => {
    return stockCheckClient.stockcheckGET(storeNumber, search, date, status, skip, take, cancelToken);
  };

  const saveStockCheck = (id: number, body?: StockCheckItem[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.save(id, body, cancelToken);
  };

  const saveStockCheckItem = (id: number, body?: StockCheckItem | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.savesingleitem(id, body, cancelToken);
  };

  const startStockCheck = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.start(id, cancelToken);
  };

  const submitStockCheck = (id: number, body?: StockCheckItem[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.submit(id, body, cancelToken);
  };

  const getStockCheckById = (id: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockCheckDetails> => {
    return stockCheckClient.stockcheckGET2(id, cancelToken);
  };

  const approveStockCheck = (id: number, body?: StockCheckItem[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.approve(id, body, cancelToken);
  };

  const exportStockCheck = (id: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> => {
    return stockCheckClient.export3(id, cancelToken);
  };

  const updateStockCheckItems = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.updateitems(id, cancelToken);
  };

  const getStockCheckByIdAndZoneId = (id: number, zoneId: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockCheckDetails> => {
    return stockCheckClient.getatlocation(id, zoneId, cancelToken);
  };

  const saveStockCheckAtLocation = (id: number, zoneId: number, body?: StockCheckItem[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.saveatlocation(id, zoneId, body, cancelToken);
  };

  const saveStockCheckItemAtLocation = (id: number, zoneId: number, body?: StockCheckItem | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.savesingleitematlocation(id, zoneId, body, cancelToken);
  };

  const submitStockCheckAtLocation = (id: number, zoneId: number, body?: StockCheckItem[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.submitatlocation(id, zoneId, body, cancelToken);
  };

  const hasOutStanding = (storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBoolean> => {
    return stockCheckClient.hasoutstanding(storeNumber, cancelToken);
  };

  const getConversions = (search?: string | undefined, uomClass?: string | undefined, skip?: number | undefined, take?: number | undefined, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetConversionsResponseDto> => {
    return conversionsClient.conversions(search, uomClass, skip, take, storeNumber, cancelToken);
  };

  const getTransactions = (store: string, from: string, to: string, search?: string | undefined, direction?: string | undefined, type?: string | undefined, reason?: string | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined, source?: string | undefined, sourceSearch?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfProductTransactionSearch> => {
    return transactionsClient.transactions(store, from, to, search, direction, type, reason, fieldToSort, sortDirection, skip, take, source, sourceSearch, cancelToken);
  };

  const getVoidedProducts = (body?: FactId [] | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfVoidedTransaction> => {
    return transactionsClient.getvoidedproducts(body, cancelToken);
  };

  const getTransactionsRag = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> => {
    return transactionsClient.rag3(cancelToken);
  };

  const getTransactionsByRagStatus = (status: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPosFeedLastReceived> => {
    return transactionsClient.getbyragstatus2(status, cancelToken);
  };

  const voidProduct = (body?: FactId | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transactionsClient.voidproduct(body, cancelToken);
  };

  const createMany = (body?: CreateMultipleTransactionsRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transactionsClient.createMany(body, cancelToken);
  };

  const getTransactionTypes = (storeNumber: string, enabled?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse> => {
    return transactionTypesClient.typesGET(storeNumber, enabled, cancelToken);
  };

  const getTransactionReasons = (actionType?: string | undefined, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetReasonsResponse> => {
    return transactionReasonsClient.reasonsGET(actionType, storeNumber, cancelToken);
  };

  const patchTransactionTypes = (id: number, body: PatchTransactionTypeRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transactionTypesClient.typesPATCH(id, body, cancelToken);
  };

  const saveTransactionReasons = (storeNumber?: string | undefined, body?: PostReasonRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transactionReasonsClient.reasonsPOST(storeNumber, body, cancelToken);
  };

  const putTransactionReasons = (id: number, body?: PostReasonRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transactionReasonsClient.reasonsPUT(id, body, cancelToken);
  };
  const deleteTransactionReasons = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transactionReasonsClient.reasonsDELETE(id, cancelToken);
  };

  const getSourceTransactions = (store: string, sourceTransactionID: string, transactionDate: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetSourceTransactionsResponse> => {
    return sourceTransactionsClient.sourcetransactions(store, sourceTransactionID, transactionDate, cancelToken);
  };

  const downloadPurchaseOrderById = (poId: number, cancelToken?: CancelToken): Promise<FileResponse> => {
    return reportsClient.getPoDetailsAsPdf(poId, cancelToken);
  };

  const getPurchaseOrdersRag = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> => {
    return purchaseOrdersClient.rag(cancelToken);
  };

  const getPurchaseOrdersByRagStatus = (status: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPurchaseOrderRag> => {
    return purchaseOrdersClient.getbyragstatus(status, cancelToken);
  };

  const getPurchaseOrders = (store?: string | undefined, id?: string | undefined, orderNumber?: string | undefined, packingSlip?: string | undefined, orderType?: string | undefined, supplierName?: string | undefined, from?: string | undefined, to?: string | undefined, deliveryDate?: string | undefined, received?: boolean | undefined, sort?: string | undefined, direction?: string | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetPurchaseOrderHeadersResponse> => {
    return purchaseOrdersClient.purchaseordersGET(store, id, orderNumber, packingSlip, orderType, supplierName, from, to, deliveryDate, received, sort, direction, skip, take, cancelToken);
  };

  const getCreditRequestStatusRag = (storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfRAG> => {
    return purchaseOrdersClient.getcreditrequeststatusrag(storeNumber, cancelToken);
  };

  const getCreditRequestStatusDataByRagStatus = (status: number, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestRag> => {
    return purchaseOrdersClient.getcreditrequeststatusdatabyrag(status, storeNumber, cancelToken);
  };

  const getCreditRequestValueData = (storeNumber?: string | undefined, showAllStores?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestValue> => {
    return purchaseOrdersClient.getcreditrequestvaluedata(storeNumber, showAllStores, cancelToken);
  };

  const allowNewReturnToVendorRequest = (purchaseOrderHeaderId: number, cancelToken?: CancelToken | undefined): Promise<boolean> => {
    return purchaseOrdersClient.allownewreturntovendorrequest(purchaseOrderHeaderId, cancelToken);
  };

  const getLocalTime = (purchaseOrderHeaderId: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfDateTime> => {
    return purchaseOrdersClient.getLocalTime(purchaseOrderHeaderId, cancelToken);
  };

  const postReturnToVendor = (body?: ReturnToVendorRequest | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPostReturnToVendorResponse> => {
    return purchaseOrdersClient.postreturntovendor(body, cancelToken);
  };

  const createPurchaseOrder = (body?: CreatePurchaseOrderHeaderRequest | undefined, cancelToken?: CancelToken | undefined): Promise<number> => {
    return purchaseOrdersClient.purchaseordersPOST(body, cancelToken);
  };

  const addItemsToPurchaseOrder = (body?: AddItemsInPurchaseOrderRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return purchaseOrdersClient.additemsinpurchaseorder(body, cancelToken);
  };

  const getPurchaseOrder = (purchaseOrderHeaderId: number, itemNumberOrDescription?: string | undefined, lineNumber?: string | undefined, sort?: string | undefined, direction?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPurchaseOrderHeader> => {
    return purchaseOrdersClient.purchaseordersGET2(purchaseOrderHeaderId, itemNumberOrDescription, lineNumber, sort, direction, cancelToken);
  };

  const getOrderTypes = (franchiseName: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfOrderTypesResponse> => {
    return purchaseOrdersClient.getOrderTypes(franchiseName, cancelToken);
  };

  const getPurchaseOrderSuppliers = (franchiseName: string, storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSupplierResponse> => {
    return purchaseOrdersClient.getPurchaseOrderSuppliers(franchiseName, storeNumber, cancelToken);
  };

  const calculatediscrepancies = (storeNumber: string, body?: CalculateDiscrepanciesLine[] | undefined, cancelToken?: CancelToken | undefined): Promise<string[]> => {
    return purchaseOrdersClient.calculatediscrepancies(storeNumber, body, cancelToken);
  };

  const purchaseordersPUT = (purchaseOrderHeaderId: number, body?: PutPurchaseOrderHeaderRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return purchaseOrdersClient.purchaseordersPUT(purchaseOrderHeaderId, body, cancelToken);
  };

  const adjustPurchaseOrder = (id: number, body?: AdjustPurchaseOrderRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return purchaseOrdersClient.adjust(id, body, cancelToken);
  };

  const getTasks = (storeNumber?: string | undefined, taskType?: string | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetTasksResponse> => {
    return tasksClient.tasks(storeNumber, taskType, skip, take, cancelToken);
  };

  const getConfigurations = (franchiseName: string, storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetConfigurationResponse> => {
    return configurationsClient.configurationsGET(franchiseName, storeNumber, cancelToken);
  };

  const updateConfiguration = (id: number, body: UpdateConfigurationRequest, cancelToken?: CancelToken | undefined): Promise<void> => {
    return configurationsClient.configurationsPATCH(id, body, cancelToken);
  };

  const getConfiguration = (configurationName: ConfigurationName, storeNumber: string, franchiseName: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetConfigurationResponse> => {
    return configurationsClient.name(configurationName, storeNumber, franchiseName, cancelToken);
  };

  const getIsConfigEnabled = (configName: string, storeNumber: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBoolean> => {
    return configurationsClient.isconfigenabled(configName, storeNumber, cancelToken);
  };

  const getPrimaryCategoriesForStore = (storeNumber: string, cancelToken?: CancelToken | undefined) => {
    return primaryCategoryClient.get2(storeNumber, cancelToken);
  };

  const getStockCheck = (storeNumber?: string | undefined, search?: string | undefined, date?: string | undefined, status?: StockCheckStatus | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfStockCheck> => {
    return stockCheckClient.stockcheckGET(storeNumber, search, date, status, skip, take, cancelToken);
  };

  const deleteStockCheck = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.stockcheckDELETE(id, cancelToken);
  };

  const getStockCheckUoms = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetStockCheckUomResponse> => {
    return stockCheckUomsClient.uoms(storeNumber, cancelToken);
  };

  const updateStockCheckUom = (body: UpdateStockCheckUomsRequest, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckUomsClient.update(body, cancelToken);
  };

  const getStoreLocations = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfLocationResponse> => {
    return locationsClient.getLocations(storeNumber, cancelToken);
  };

  const getLocation = (locationId: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfLocationResponse> => {
    return locationsClient.getlocation(locationId, cancelToken);
  };

  const createLocation = (body: LocationRequest | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPostLocationResponse> => {
    return locationsClient.createlocation(body, cancelToken);
  };

  const updateLocation = (body: LocationRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> => {
    return locationsClient.updatelocation(body, cancelToken);
  };

  const deleteLocation = (locationId: number | undefined, cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> => {
    return locationsClient.deletelocation(locationId, cancelToken);
  };

  const getStores = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStoreListResponse> => {
    return storesClient.storesGET(cancelToken);
  };

  const getFranchiseStores = (franchiseName?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStoreListResponse> => {
    return storesClient.franchisename(franchiseName, cancelToken);
  };
  const getListFranchiseStores = (franchiseName?: string[] | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStoreListResponse> => {
    return storesClient.franchiseinclude(franchiseName, cancelToken);
  };
  const createTransfer = (body?: CreateTransferRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transfersClient.transfersPOST(body, cancelToken);
  };

  const getTransfers = (storeNumber?: string | undefined, transferNumber?: number | undefined, transferType?: string | undefined, date?: string | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined, archived?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetTransfersResponse> => {
    return transfersClient.transfersGET(storeNumber, transferNumber, transferType, date, fieldToSort, sortDirection, skip, take, archived, cancelToken);
  };

  const getTransfer = (id: number, userStore?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfTransferHeader> => {
    return transfersClient.transfersGET2(id, userStore, cancelToken);
  };

  const receiveTransfer = (id: number, body?: ReceiveTransferHeaderRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transfersClient.transfersPATCH(id, body, cancelToken);
  };

  const deactivateTransfer = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return transfersClient.transfersDELETE(id, cancelToken);
  };

  const validateTransferItemQuantity = (body?: ValidateItemQuantityRequest | undefined, cancelToken?: CancelToken | undefined): Promise<ValidateItemQuantityResponse> => {
    return transfersClient.validateitemquantity(body, cancelToken);
  };

  const getInvoices = (storeNumber?: string | undefined, invoiceNumber?: string | undefined, orderNumber?: string | undefined, ewsOrderNumber?: string | undefined, from?: string | undefined, to?: string | undefined, status?: string | undefined, sort?: string | undefined, direction?: string | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetInvoicesResponse> => {
    return invoiceClient.invoiceGET(storeNumber, invoiceNumber, orderNumber, ewsOrderNumber, from, to, status, sort, direction, skip, take, cancelToken);
  };

  const getInvoice = (invoiceId: number, status?: string | undefined, sort?: string | undefined, direction?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfInvoice> => {
    return invoiceClient.invoiceGET2(invoiceId, status, sort, direction, cancelToken);
  };

  const postInvoice = (invoiceId: number, body?: UpdateInvoiceRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return invoiceClient.invoicePOST(invoiceId, body, cancelToken);
  };

  const postInvoiceItem = (invoiceId: number, invoiceItemId: number, body?: UpdateInvoiceRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return invoiceClient.invoicePOST2(invoiceId, invoiceItemId, body, cancelToken);
  };

  const getWaste = (storeNumber?: string | undefined, date?: string | undefined, skip?: number | undefined, take?: number | undefined, type?: number | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPagedData_1OfWasteHeaders> => {
    return wasteClient.wasteGET2(storeNumber, date, skip, take, type, fieldToSort, sortDirection, cancelToken);
  };

  const getWasteById = (id: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfWasteCheckSheetResponse> => {
    return wasteClient.wasteGET(id, cancelToken);
  };

  const createWaste = (body?: WasteCheckSheetRequest | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfInt32> => {
    return wasteClient.create2(body, cancelToken);
  };

  const deleteWaste = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return wasteClient.wasteDELETE(id, cancelToken);
  };

  const submitWaste = (body?: WasteCheckSheetRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return wasteClient.submit2(body, cancelToken);
  };

  const getItems = (
    search?: string | undefined,
    storeNumber?: string | undefined,
    hasRecentActivity?: boolean | undefined,
    isMadeInStore?: boolean | undefined,
    isStockItem?: boolean | undefined,
    isSaleItem?: boolean | undefined,
    isProduct?: boolean | undefined,
    isMaterial?: boolean | undefined,
    excludeRecipes?: boolean | undefined,
    isDailyWaste?: boolean | undefined,
    sort?: string | undefined,
    direction?: string | undefined,
    skip?: number | undefined,
    take?: number | undefined,
    addItems?: boolean | undefined,
    cancelToken?: CancelToken | undefined,
  ): Promise<SuccessResponse_1OfGetItemsResponse> => {
    return itemsClient.get(search, storeNumber, hasRecentActivity, isMadeInStore, isStockItem, isSaleItem, isProduct, isMaterial, excludeRecipes, isDailyWaste, sort, direction, skip, take, addItems, cancelToken);
  };

  const getByItemNumber = (itemNumber: string, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfItem> => {
    return itemsClient.getByItemNumber(itemNumber, storeNumber, cancelToken);
  };

  const getItemDailyHistory = (itemNumber: string, storeNumber: string, fromDate: string, toDate: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItemDailyHistory> => {
    return itemHistoryClient.getitemdailyhistory(itemNumber, storeNumber, fromDate, toDate, cancelToken);
  };

  const getItemCostHistory = (itemNumber: string, storeNumber: string, date?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfCostHistory> => {
    return itemHistoryClient.getitemcosthistoriesbyitemnumber(itemNumber, storeNumber, date, cancelToken);
  };

  const getItemHistoryReportById = (body?: RequestItemHistoryReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> => {
    return reportsClient.getItemHistoryReportById(body, cancelToken);
  };

  const getItemsByIds = (body?: GetItemsByIdsRequest | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> => {
    return itemsClient.getByIds(body, cancelToken);
  };

  const getItemsByStoreNumbers = (body?: GetItemsByStoresRequest | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> => {
    return itemsClient.getByStoreNumbers(body, cancelToken);
  };
  const getItemsSearchedByStoreNumbers = (body?: SearchItemsByStoresRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> => {
    return itemsClient.searchByStoreNumbers(body, cancelToken);
  };
  const getStockItems = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> => {
    return itemsClient.getStockItems(storeNumber, cancelToken);
  };

  const getRecipeChanges = (search?: string | undefined, storeNumber?: string | undefined, skip?: number | undefined, take?: number | undefined, isNew?: boolean | undefined, applied?: boolean | undefined, disregarded?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<PagedData_1OfItemFeedChange> => {
    return itemsClient.getRecipeChanges(search, storeNumber, skip, take, isNew, applied, disregarded, cancelToken);
  };

  const getFranchiseRecipeChanges = (franchiseName?: string | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedData_1OfGroupedItemFeedChange> => {
    return itemsClient.getFranchiseRecipeChanges(franchiseName, skip, take, cancelToken);
  };

  const disregardChange = (itemFeedChangeId: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return itemsClient.disregardChange(itemFeedChangeId, cancelToken);
  };

  const applyChange = (itemFeedChangeId: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return itemsClient.applyChange(itemFeedChangeId, cancelToken);
  };

  const disregardChanges = (body?: number[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return itemsClient.disregardChanges(body, cancelToken);
  };

  const applyChanges = (body?: number[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return itemsClient.applyChanges(body, cancelToken);
  };

  const getAllStoresRecipeChanges = (skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedData_1OfGroupedItemFeedChange> => {
    return itemsClient.getAllStoresRecipeChanges(skip, take, cancelToken);
  };

  const getChangeDetails = (itemFeedChangeId: number, cancelToken?: CancelToken | undefined): Promise<ItemCompare> => {
    return itemsClient.getChangeDetails(itemFeedChangeId, cancelToken);
  };

  const getTransferItems = (search?: string | undefined, from?: string | undefined, to?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetItemsResponse> => {
    return itemsClient.getTransferItems(search, from, to, cancelToken);
  };

  const getUoms = (itemNumber: string, storeNumber?: string | undefined, withoutWeight?: boolean | undefined, withoutLiquid?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetUomsResponse> => {
    return itemsClient.getUoms(itemNumber, storeNumber, withoutWeight, withoutLiquid, cancelToken);
  };

  const getRecipes = (search?: string | undefined, storeNumber?: string | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedData_1OfRecipe> => {
    return itemAndComponentClient.itemandcomponentGET(search, storeNumber, skip, take, cancelToken);
  };

  const addComponent = (body?: UpsertItemComponent | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return itemAndComponentClient.componentPOST(body, cancelToken);
  };

  const deleteComponent = (itemId: number, componentItemId: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return itemAndComponentClient.componentDELETE(itemId, componentItemId, cancelToken);
  };

  const deleteIngredient = (itemId: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return itemAndComponentClient.itemandcomponentDELETE(itemId, cancelToken);
  };

  const exportRecipes = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> => {
    return itemAndComponentClient.export2(storeNumber, cancelToken);
  };

  const getMadeInStore = (search?: string | undefined, storeNumber?: string | undefined, skip?: number | undefined, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedData_1OfMadeInStoreItem> => {
    return madeInStoreClient.madeinstoreGET(search, storeNumber, skip, take, cancelToken);
  };

  const createMadeInStore = (body?: CreateMadeInStoreItemRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItemRecipeSummary> => {
    return madeInStoreClient.madeinstorePOST(body, cancelToken);
  };

  const updateMadeInStore = (body?: MadeInStoreItemRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return madeInStoreClient.create(body, cancelToken);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getStoreItems = (body?: GetItemsRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<any> => {
    return madeInStoreClient.storeItems(body, cancelToken);
  };

  const getActualTheorySummariesReport = (from?: string | undefined, to?: string | undefined, userLevel?: string | undefined, cancelToken?: CancelToken | undefined): Promise<ActualTheorySummary[]> => {
    return reportsClient.getActualTheorySummaries(from, to, userLevel, cancelToken);
  };

  const getExtendedStockCheckReport = (stockCheckId: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> => {
    return reportsClient.getExtendedStockCheckReportByIdAsPdf(stockCheckId, cancelToken);
  };

  const getReport = (id: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> => {
    return reportsClient.getReport(id, cancelToken);
  };

  const getReportAvailableDates = (storeNumbers?: string | undefined, districtIds?: string | undefined, allStores?: boolean | undefined, numberOfWeeks?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfDateTime> => {
    return reportsClient.getAvailableReportingDates(storeNumbers, districtIds, allStores, numberOfWeeks, cancelToken);
  };

  const getReportsAvailableForDownload = (cancelToken?: CancelToken | undefined) => {
    return reportsClient.get3(cancelToken);
  };

  const getStockCountReportById = (stockCountId: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> => {
    return reportsClient.getStockCountReportById(stockCountId, cancelToken);
  };

  const getUserReport = (userId: number, id: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> => {
    return reportsClient.getUserReport(userId, id, cancelToken);
  };

  const getUserReports = (userId: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetReportsResponse> => {
    return reportsClient.getUserReports(userId, cancelToken);
  };

  const runCheckReport = (body?: CheckReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getCheckReport(body, cancelToken);
  };

  const runCOGsReport = (body?: RequestCOGsReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getCOGsReport(body, cancelToken);
  };

  const runConstrainedItemReport = (body?: ConstrainedItemReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getConstrainedItemReport(body, cancelToken);
  };

  const runCostOfSalesReport = (body?: CostOfSalesRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getCostOfSalesReport(body, cancelToken);
  };

  const runCreditPurchaseReport = (body?: CreditPurchaseReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getCreditPurchaseReport(body, cancelToken);
  };

  const runDcShortageReport = (body?: DcShortageReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getDcShortageReport(body, cancelToken);
  };

  const runExtendedStockCountReport = (body?: ExtendedStockCountReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getExtendedStockCountReport(body, cancelToken);
  };

  const runItemActivityReport = (body?: ItemActivityReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getItemActivityReport(body, cancelToken);
  };

  const runItemStockOutReport = (body?: ItemStockOutRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getItemStockOutReport(body, cancelToken);
  };

  const runItemUsageReport = (body?: ItemUsageReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getItemUsageReport(body, cancelToken);
  };

  const runReturnablePackagingReport = (body?: ReturnablePackagingReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getReturnablePackagingReport(body, cancelToken);
  };

  const runItemTimeoutReport = (body?: ItemTimeOutRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getItemTimeOutReport(body, cancelToken);
  };

  const runInvoiceReport = (body?: InvoiceReconciliationRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getInvoiceReconciliationReport(body, cancelToken);
  };

  const runMadeInStoreReport = (body?: MadeInStoreReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getMadeInStoreReport(body, cancelToken);
  };

  const runProductMarginReport = (body?: ProductMarginReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getProductMarginReport(body, cancelToken);
  };

  const runReceiptsReport = (body?: ReceiptsReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getReceiptsReport(body, cancelToken);
  };

  const runAmRestReceiptsReport = (body?: ReceiptsReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getAmRestReceiptsReport(body, cancelToken);
  };

  const runStockCountSummaryReport = (stockCountSummaryReportRequest?: StockCountSummaryReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getStockCountSummaryReport(stockCountSummaryReportRequest, cancelToken);
  };

  const runStockCountsVsUsageReport = (body?: RequestStockCountsVsUsageReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getStockCountsVsUsageReport(body, cancelToken);
  };

  const runStockDaysReport = (body?: StockDaysRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getStockDaysReport(body, cancelToken);
  };

  const runStockOnHandReport = (body?: StockOnHandReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getStockOnHandReport(body, cancelToken);
  };

  const runTheoryActualReport = (body?: RequestTheoryActualReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getTheoryActualReport(body, cancelToken);
  };

  const runTransfersReport = (body?: TransfersReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getTransfersReport(body, cancelToken);
  };

  const runWasteReport = (body?: WasteReportRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getWasteReport(body, cancelToken);
  };

  const getPodPerformanceReport = (body: AIPerformanceReportRequest, cancelToken?: CancelToken | undefined): Promise<void> => {
    return reportsClient.getAIPerformanceReport(body, cancelToken);
  };

  const getPodWidgetData = (type: PodWidgetType, storeNo: string): Promise<PodWidgetData> => {
    return reportsClient.widget(type, storeNo);
  };

  const getStoreUsersWithRole = (role: Roles, storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfUser> => {
    return usersClient.getStoreUsersWithRole(role, storeNumber, cancelToken);
  };

  const getDistrictsByFranchise = (franchiseName: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict> => {
    return districtsClient.districts(franchiseName, cancelToken);
  };

  const getsStockCheckSchedule = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfStockCheckScheduleDetail> => {
    return stockCheckScheduleClient.stockcheckscheduleGET(storeNumber, cancelToken);
  };

  const deleteSchedule = (storeNumber: string, id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckScheduleClient.scheduleDELETE(storeNumber, id, cancelToken);
  };

  const getStockCheckScheduleByNumber = (storeNumber: string, id: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockCheckScheduleDetails> => {
    return stockCheckScheduleClient.scheduleGET(storeNumber, id, cancelToken);
  };

  const stockcheckschedulePOST = (storeNumber: string, body?: StockCheckScheduleDetail | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckScheduleClient.stockcheckschedulePOST(storeNumber, body, cancelToken);
  };

  const generatestockchecks = (storeNumber: string, scheduleId: number, cancelToken?: CancelToken | undefined): Promise<GenerateStockCheckResponse> => {
    return stockCheckScheduleClient.generatestockchecks(storeNumber, scheduleId, cancelToken);
  };

  const duplicateStockCheck = (storeNumber: string, id: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfInt32> => {
    return stockCheckScheduleClient.duplicate(storeNumber, id, cancelToken);
  };

  const getCategories = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfPrimaryCategoryStockCount> => {
    return primaryCategoryClient.getWithCounts(storeNumber, cancelToken);
  };

  const getItemsById = (body?: GetItemsByIdsRequest | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItem> => {
    return itemsClient.getByIds(body, cancelToken);
  };

  const createStockCounts = (body?: StockCheck | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockCheckClient.stockcheckPOST(body, cancelToken);
  };

  const getAllNotifications = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> => {
    return notificationsClient.getallnotification(storeNumber, cancelToken);
  };

  const saveNotification = (body: Notification | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfNotification> => {
    return notificationsClient.notificationsPOST(body, cancelToken);
  };

  const deleteNotification = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return notificationsClient.notificationsDELETE(id, cancelToken);
  };

  const getNotifications = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> => {
    return notificationsClient.getnotification(storeNumber, cancelToken);
  };

  const getCreditRequest = (purchaseOrderHeaderId: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCreditRequestsValuesResponse> => {
    return purchaseOrdersClient.getPurchaseOrdersCreditRequests(purchaseOrderHeaderId, cancelToken);
  };

  const getCreditRequestDetails = (purchaseOrderHeaderId?: number | undefined, itemNumberOrDescription?: string | undefined, lineNumber?: string | undefined, sort?: string | undefined, direction?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPurchaseOrderHeader> => {
    return purchaseOrdersClient.getbyorderid(purchaseOrderHeaderId, itemNumberOrDescription, lineNumber, sort, direction, cancelToken);
  };

  const getReturnToVendorDetails = (returnToVendorId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfReturnToVendorHeaders> => {
    return purchaseOrdersClient.getreturntovendordetails(returnToVendorId, cancelToken);
  };

  const sendCreditRequest = (body?: SendCreditReqRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> => {
    return purchaseOrdersClient.sendcreditrequest(body, cancelToken);
  };

  const sendReturnToVendorCreditRequest = (body?: SendCreditReqRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> => {
    return purchaseOrdersClient.sendreturntovendorrequest(body, cancelToken);
  };

  const getFranchiseOrderTypeStatus = (franchiseName: string | undefined, orderType: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfFranchiseOrderTypes> => {
    return purchaseOrdersClient.getfranchiseordertypestatus(franchiseName, orderType, cancelToken);
  };

  const getCreditRequestCutOff = (ewsOrderNumber: string, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<string> => {
    return purchaseOrdersClient.getcreditrequestcutoff(ewsOrderNumber, storeNumber, cancelToken);
  };

  const beginCreditRequest = (body?: BeginCreditReqRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericCreditRequestResponse> => {
    return purchaseOrdersClient.begincreditrequest(body, cancelToken);
  };

  const getStock = (
    storeNumber: string,
    search?: string,
    fieldToSort?: string,
    sortDirection?: string,
    skip?: number,
    take?: number,
    filters?: string,
    categoryFilters?: string,
    storeFilters?: string,
    hasRecentActivity?: boolean,
    isMadeInStore?: boolean,
    cancelToken?: CancelToken,
  ): Promise<SuccessResponse_1OfGetStockResponse> => {
    return stockClient.stockGET(
      storeNumber,
      search,
      fieldToSort,
      sortDirection,
      skip,
      take,
      filters,
      categoryFilters,
      storeFilters,
      hasRecentActivity,
      isMadeInStore,
      cancelToken,
    );
  };

  const updateStock = (body?: PutStockRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return stockClient.stockPUT(body, cancelToken);
  };

  const getUsersByFranchise = (franchiseName?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfUserListResponse> => {
    return usersClient.franchisename2(franchiseName, cancelToken);
  };

  const getOneStock = (itemNumber: string, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockItem> => {
    return stockClient.stockGET2(itemNumber, storeNumber, cancelToken);
  };

  const getPersonas = (franchiseName?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfPersona> => {
    return personaClient.personasGET(franchiseName, cancelToken);
  };

  const editPersona = (id: number, body?: PutPersonaRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return personaClient.personasPUT(id, body, cancelToken);
  };

  const deletePersona = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return personaClient.personasDELETE(id, cancelToken);
  };

  const createPersona = (body?: PostPersonaRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return personaClient.personasPOST(body, cancelToken);
  };

  const getFranchises = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfFranchise> => {
    return storesClient.franchises(cancelToken);
  };

  const getRoles = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString> => {
    return rolesClient.rolesGET(cancelToken);
  };

  const getAutomatedTasks = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfAutomatedTask> => {
    return automatedTask.automatedtaskGET(storeNumber, cancelToken);
  };

  const saveAutomatedTasks = (body?: AutomatedTask | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return automatedTask.automatedtaskPOST(body, cancelToken);
  };

  const deleteAutomatedTasks = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return automatedTask.automatedtaskDELETE(id, cancelToken);
  };

  const getUsers = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfUserListResponse> => {
    return usersClient.usersGET(cancelToken);
  };

  const getPreviewDates = (body?: AutomatedTask | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate> => {
    return automatedTask.previewdates(body, cancelToken);
  };

  const getAutomatedTasksById = (id: number, storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfAutomatedTaskDetails> => {
    return automatedTask.task(id, storeNumber, cancelToken);
  };

  const getReminderRoles = (cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString> => {
    return rolesClient.reminderroles(cancelToken);
  };

  const createUser = (body?: CreateUserRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return usersClient.usersPOST(body, cancelToken);
  };

  const deleteUser = (id: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return usersClient.usersDELETE(id, cancelToken);
  };

  const deletePrimaryCategory = (storeNumber: string, id: number, substituteId: number, cancelToken?: CancelToken | undefined): Promise<void> => {
    return primaryCategoryClient.delete(storeNumber, id, substituteId, cancelToken);
  };

  const savePrimaryCategory = (body?: PrimaryCategory | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfPrimaryCategory> => {
    return primaryCategoryClient.post(body, cancelToken);
  };

  const bulkAddPrimaryCategory = (id: number, body?: string[] | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfBulkAddResponse> => {
    return primaryCategoryClient.postAddBulk(id, body, cancelToken);
  };

  const applyCategories = (storeNumber: string, cancelToken?: CancelToken | undefined): Promise<void> => {
    return primaryCategoryClient.applyPrimaryCategory(storeNumber, cancelToken);
  };

  const updateCategoryWasteCheckSheet = (id: number, value: boolean, cancelToken?: CancelToken | undefined): Promise<void> => {
    return primaryCategoryClient.updateCategoryWasteCheckSheet(id, value, cancelToken);
  };

  const updateCategorySalesForecast = (id: number, value: boolean, cancelToken?: CancelToken | undefined): Promise<void> => {
    return primaryCategoryClient.updateCategorySalesForecast(id, value, cancelToken);
  };

  const editUser = (id: number, body?: PutUserRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> => {
    return usersClient.usersPUT(id, body, cancelToken);
  };

  const getPOSMappings = (franchiseId?: number, sku?: string, mappingType?: string, store?: string, sortField?: string, sortDirection?: string, skip?: number, take?: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfPagedData_1OfGetPosMappingResponse> => {
    return posMappingClient.posmappingGET(franchiseId, sku, mappingType, store, sortField, sortDirection, skip, take, cancelToken);
  };
  
  const createPosMapping = (body: PostPosMappingRequest, cancelToken?: CancelToken): Promise<void> => {
    return posMappingClient.posmappingPOST(body, cancelToken);
  };

  const updatePosMapping = (body: PutPosMappingRequest, cancelToken?: CancelToken): Promise<void> => {
    return posMappingClient.posmappingPUT(body, cancelToken);
  };

  const deletePosMapping = (body: DeletePosMappingRequest, cancelToken?: CancelToken): Promise<void> => {
    return posMappingClient.posmappingDELETE(body, cancelToken);
  };

  const getPaperPackagingMappings = (franchiseId?: number, itemNumber?: string, paperPackagingType?: number, store?: string, sortField?: string, sortDirection?: string, skip?: number, take?: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfPagedData_1OfGetPaperPackagingResponse> => {
    return paperPackagingClient.paperpackagingGET(franchiseId, itemNumber, paperPackagingType, store, sortField, sortDirection, skip, take, cancelToken);
  };

  const createPaperPackagingMapping = (body: PostPaperPackagingRequest, cancelToken?: CancelToken): Promise<void> => {
    return paperPackagingClient.paperpackagingPOST(body, cancelToken);
  };

  const updatePaperPackagingMapping = (body: PutPaperPackagingRequest, cancelToken?: CancelToken): Promise<void> => {
    return paperPackagingClient.paperpackagingPUT(body, cancelToken);
  };
  
  const deletePaperPackagingMapping = (body: DeletePaperPackagingRequest, cancelToken?: CancelToken): Promise<void> => {
    return paperPackagingClient.paperpackagingDELETE(body, cancelToken);
  };

  const getTransportCosts = (
    storeNumber?: string,
    cancelToken?: CancelToken,
  ): Promise<SuccessResponse_1OfList_1OfTransportCost> => {
    return transportCostClient.transportcostsGET(storeNumber, cancelToken);
  };

  const getTransportCostById = (
    id: number,
    cancelToken?: CancelToken,
  ): Promise<SuccessResponse_1OfTransportCost> => {
    return transportCostClient.transportcostsGET2(id, cancelToken);
  };

  const createTransportCost = (
    body?: TransportCost,
    cancelToken?: CancelToken,
  ): Promise<void> => {
    return transportCostClient.transportcostsPOST(body, cancelToken);
  };

  const updateTransportCost = (
    id: number,
    body: TransportCost,
    cancelToken?: CancelToken,
  ): Promise<void> => {
    return transportCostClient.transportcostsPUT(id, body, cancelToken);
  };

  const downloadBulkUserTemplate = (franchiseName?: string, cancelToken?: CancelToken) => {
    return usersClient.exporttemplate(franchiseName, cancelToken);
  };

  const bulkUserActions = (body: BulkUserActionRequest[], cancelToken?: CancelToken) => {
    return usersClient.bulkusersactions(body, cancelToken);
  };

  return {
    downloadPurchaseOrderById,
    getCurrentUser,
    resetPassword,
    activateUser,
    getStockCheckDetails,
    getStockCheckRag,
    getStockCheckByRagStatus,
    getStockChecks,
    saveStockCheck,
    saveStockCheckItem,
    getStockCheck,
    startStockCheck,
    submitStockCheck,
    hasOutStanding,
    approveStockCheck,
    exportStockCheck,
    updateStockCheckItems,
    saveStockCheckAtLocation,
    saveStockCheckItemAtLocation,
    getStockCheckByIdAndZoneId,
    submitStockCheckAtLocation,
    getConversions,
    getTransactions,
    getTransactionsRag,
    getTransactionsByRagStatus,
    getVoidedProducts,
    voidproduct: voidProduct,
    getTransactionTypes,
    getTransactionReasons,
    createMany,
    getPurchaseOrdersRag,
    getPurchaseOrdersByRagStatus,
    getPurchaseOrders,
    purchaseordersPUT,
    adjustPurchaseOrder,
    getCreditRequestStatusRag,
    getCreditRequestStatusDataByRagStatus,
    getCreditRequestValueData,
    allowNewReturnToVendorRequest,
    getLocalTime,
    postReturnToVendor,
    getOrderTypes,
    getPurchaseOrderSuppliers,
    createPurchaseOrder,
    addItemsToPurchaseOrder,
    getPurchaseOrder,
    calculatediscrepancies,
    getTasks,
    getConfigurations,
    getConfiguration,
    getIsConfigEnabled,
    updateConfiguration,
    getStores,
    getFranchiseStores,
    getReportsAvailableForDownload,
    getPrimaryCategoriesForStore,
    getStoreLocations,
    getLocation,
    createLocation,
    updateLocation,
    deleteLocation,
    createTransfer,
    getTransfers,
    getTransfer,
    receiveTransfer,
    deactivateTransfer,
    validateTransferItemQuantity,
    getInvoices,
    getInvoice,
    postInvoice,
    postInvoiceItem,
    getWaste,
    getWasteById,
    createWaste,
    deleteWaste,
    submitWaste,
    getFranchises,
    getItems,
    getItemsByIds,
    getItemsByStoreNumbers,
    getItemsSearchedByStoreNumbers,
    getByItemNumber,
    getChangeDetails,
    generatestockchecks,
    getStockItems,
    getTransferItems,
    getUoms,
    getStockCheckById,
    getRecipeChanges,
    getRecipes,
    getFranchiseRecipeChanges,
    disregardChange,
    applyChange,
    disregardChanges,
    applyChanges,
    getAllStoresRecipeChanges,
    deleteIngredient,
    getActualTheorySummariesReport,
    getExtendedStockCheckReport,
    getReport,
    getReportAvailableDates,
    getStockCountReportById,
    getUserReport,
    getUserReports,
    getStockCheckScheduleByNumber,
    stockcheckschedulePOST,
    runCheckReport,
    runCOGsReport,
    runConstrainedItemReport,
    runCostOfSalesReport,
    runCreditPurchaseReport,
    runDcShortageReport,
    runExtendedStockCountReport,
    runInvoiceReport,
    runItemActivityReport,
    runItemStockOutReport,
    runItemUsageReport,
    runReturnablePackagingReport,
    runItemTimeoutReport,
    runMadeInStoreReport,
    runProductMarginReport,
    runReceiptsReport,
    runAmRestReceiptsReport,
    runStockCountSummaryReport,
    runStockCountsVsUsageReport,
    runStockDaysReport,
    runStockOnHandReport,
    runTheoryActualReport,
    runTransfersReport,
    runWasteReport,
    getStoreUsersWithRole,
    getDistrictsByFranchise,
    getsStockCheckSchedule,
    deleteSchedule,
    getCategories,
    deleteStockCheck,
    getStockCheckUoms,
    updateStockCheckUom,
    getPersonas,
    editPersona,
    createPersona,
    deletePersona,
    getRoles,
    getStock,
    getItemsById,
    createStockCounts,
    getMadeInStore,
    createMadeInStore,
    addComponent,
    deleteComponent,
    updateMadeInStore,
    saveTransactionReasons,
    putTransactionReasons,
    patchTransactionTypes,
    deleteTransactionReasons,
    getSourceTransactions,
    getItemDailyHistory,
    getItemCostHistory,
    updateStock,
    getAutomatedTasks,
    deleteAutomatedTasks,
    getAutomatedTasksById,
    getAllNotifications,
    saveNotification,
    deleteNotification,
    getCreditRequest,
    getCreditRequestDetails,
    getReturnToVendorDetails,
    sendCreditRequest,
    sendReturnToVendorCreditRequest,
    getFranchiseOrderTypeStatus,
    getCreditRequestCutOff,
    beginCreditRequest,
    getReminderRoles,
    saveAutomatedTasks,
    getPreviewDates,
    getUsers,
    createUser,
    editUser,
    deleteUser,
    deletePrimaryCategory,
    bulkAddPrimaryCategory,
    updateCategorySalesForecast,
    updateCategoryWasteCheckSheet,
    savePrimaryCategory,
    applyCategories,
    exportRecipes,
    getNotifications,
    getStoreItems,
    getItemHistoryReportById,
    getOneStock,
    getUsersByFranchise,
    getPOSMappings,
    createPosMapping,
    updatePosMapping,
    deletePosMapping,
    getListFranchiseStores,
    getPodPerformanceReport,
    getPodWidgetData,
    getPaperPackagingMappings,
    createPaperPackagingMapping,
    updatePaperPackagingMapping,
    deletePaperPackagingMapping,
    getTransportCosts,
    getTransportCostById,
    createTransportCost,
    updateTransportCost,
    downloadBulkUserTemplate,
    bulkUserActions,
    duplicateStockCheck,
  };
};

export default useNswagClient;